import React from 'react';
import { IconButton, Box } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useHistory } from 'react-router-dom';
import { CreditAppTableRow } from 'modules/customers/types';

interface Props {
  row: CreditAppTableRow;
}

export const ActionCell = ({ row }: Props) => {
  const history = useHistory();

  const handleGoToOpportunity = () => {
    window.open(`/vo/${row.vendorOpportunityId}`, '_blank');
    //history.push(`/vo/${row.vendorOpportunityId}`);
  };

  return (
    <Box>
      <IconButton color="primary" size="small" onClick={() => handleGoToOpportunity()}>
        <OpenInNewIcon />
      </IconButton>
    </Box>
  );
};
